import { Modal, Button } from "antd";
import warningIcon from "@/static/images/warning_icon.png";

import "./index.css";

const WorkDeleteModal: React.FC<any> = ({
  deleteModalVisible,
  setDeleteModalVisible,
  removeWork,
  workId,
}: any) => {
  return (
    <Modal
      open={deleteModalVisible}
      onCancel={() => setDeleteModalVisible(false)}
      footer={null}
      centered
      closable
      width={334}
      height={171}
      zIndex={10002}
      styles={{
        body: {
          padding: "10px 1px 3px 20px",
          borderRadius: 30,
        },
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "row",
        }}
      >
        <img
          src={warningIcon}
          style={{
            width: 26,
            height: 26,
            marginRight: 5,
            // alignSelf: "center",
            // alignItems: "center",
          }}
        ></img>
        <p style={{ fontSize: 16, marginBottom: 8, fontWeight: "bold" }}>
          确定要删除吗？
        </p>
      </div>
      <div style={{ fontSize: 14, marginBottom: 40 }}>
        删除项目之后无法恢复！
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
        <Button
          type="default"
          style={{
            borderColor: "#409EFF",
            color: "#409EFF",
            width: 88,
            height: 40,
            fontSize: 16,
            borderRadius: 20,
          }}
          onClick={() => {
            setDeleteModalVisible(false);
            removeWork(workId);
          }}
        >
          确定
        </Button>
        <Button
          type="primary"
          style={{
            background: "#409EFF",
            borderColor: "#409EFF",
            width: 88,
            height: 40,
            borderRadius: 20,
            fontSize: 16,
          }}
          onClick={() => setDeleteModalVisible(false)}
        >
          取消
        </Button>
      </div>
    </Modal>
  );
};

export default WorkDeleteModal;
